<!-- <div #editorContainer class="editor-container"></div> -->

<ngx-monaco-editor
      class="editor editor-container"
      [options]="editorOptions"
      [(ngModel)]="valueInternal"
      (onInit)="onEditorInit($event)">
    </ngx-monaco-editor>
